import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Conclusionpoint() {
  return (
    <section className="key_findings p-100 text_white bg_purple_color">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="conc_img">
              <StaticImage
                src="../../../images/case-studies/rev-coin/key_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={437}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>
              Key Findings and{" "}
              <span style={{ color: "#CCE715" }}> Recommendations</span>
            </h2>
            <p>
              Based on the study of the Rev Coin implementation, numerous key
              findings emerge.
            </p>
            <ul>
              <li>
                The transparency and control offered by blockchain technology
                suggestively improve employee engagement and loyalty.
              </li>
              <li>
                The resourceful technical implementation modernizes processes,
                making it easier for employees to buy, sell, and transfer Rev
                Coin.
              </li>
            </ul>
            <p>
              Nevertheless, further optimization can be done to enhance user
              experience and guarantee a seamless integration with existing
              platforms.
            </p>
            <p>
              It is suggested to conduct regular audits to sustain security and
              address any possible liabilities.
            </p>
            <p>
              Moreover, constant monitoring and analysis of employee feedback
              will offer insights to fine-tune the Rev Coin ecosystem and modify
              it to meet growing employee needs and prospects.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Conclusionpoint;
